import { css } from 'aphrodite';
import { Control, FormState } from 'react-hook-form';
import { IDonationSurvey } from '../../../../models/Api';
import { IFormValues } from '../utils';
import { CustomFormFieldRenderer } from './CustomFormFieldRenderer';
import { styleSheet } from './styles';

type IProps = {
	survey: IDonationSurvey;
	control: Control<IFormValues>;
	formState: FormState<IFormValues>;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
};

export const CustomForm = ({ survey, control, formState, setValue }: IProps) => {
	return (
		<div>
			<div className={css(styleSheet.customFormSection)}>
				{survey.customForm.fields
					?.filter(f => !f.isHidden)
					.map(field => (
						<CustomFormFieldRenderer
							key={field.id}
							field={field}
							control={control}
							formState={formState}
							setValue={setValue}
						/>
					))}
			</div>
		</div>
	);
};
